import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
const LOCATIONS = [{
  name: 'Howell Showroom & Main Service Center',
  address: '222 W Grand River Ave, Howell, MI 48843',
  phone: '517-545-7772',
  phoneLink: 'tel:5175457772'
}, {
  name: 'Ann Arbor Satellite Office',
  address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
  phone: '734-887-6556',
  phoneLink: 'tel:7348876556'
}, {
  name: 'Novi Satellite Office',
  address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
  phone: '248-924-9899',
  phoneLink: 'tel:2489249899'
}];
export function ServiceArea() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50" data-id="element-1394">
      <div className="max-w-7xl mx-auto" data-id="element-1395">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-1396">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-1397">
            Residential Glass Repair Near Howell, Ann Arbor, Novi & Southeast
            Michigan
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-1398">
            Kosin's Glass serves homeowners across Southeast Michigan, including
            Howell, Ann Arbor, Novi, Brighton, Fenton, Hartland, Fowlerville,
            Northville, Lansing, East Lansing, Grand Blanc, Webberville,
            Williamston, Livonia, Milford, Pinckney, Whitmore Lake, Wixom and
            nearby communities.
          </p>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-1399">
          {LOCATIONS.map((loc, idx) => <li key={idx} data-id="element-1400">
              <article className="bg-white rounded-2xl p-8 shadow-soft border border-slate-200 flex flex-col items-center text-center h-full anim-on-scroll" data-id="element-1401">
                <div className="w-12 h-12 rounded-full bg-brandBlue-50 flex items-center justify-center mb-4" data-id="element-1402">
                  <MapPin className="w-6 h-6 text-brandBlue-600" aria-hidden="true" data-id="element-1403" />
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-1404">
                  {loc.name}
                </h3>
                <p className="text-slate-600 mb-6 flex-grow" data-id="element-1405">{loc.address}</p>
                <a href={loc.phoneLink} className="inline-flex items-center gap-2 text-brandBlue-600 font-bold hover:text-brandBlue-700 transition-colors" data-id="element-1406">
                  <Phone className="w-5 h-5" aria-hidden="true" data-id="element-1407" />
                  {loc.phone}
                </a>
              </article>
            </li>)}
        </ul>
        <div className="bg-white rounded-2xl p-8 shadow-soft border border-slate-200 max-w-2xl mx-auto text-center" data-id="element-1408">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-1409">
            <Clock className="w-6 h-6 text-navy-900" aria-hidden="true" data-id="element-1410" />
            <h3 className="text-xl font-bold text-navy-900" data-id="element-1411">
              Hours of Operation
            </h3>
          </div>
          <ul className="text-slate-600 space-y-2 text-lg" data-id="element-1412">
            <li data-id="element-1413">Monday–Friday: 8:00 a.m. to 5:00 p.m.</li>
            <li data-id="element-1414">Saturday: 9:00 a.m. to 3:00 p.m.</li>
            <li data-id="element-1415">Sunday: Closed</li>
          </ul>
        </div>
      </div>
    </section>;
}